import { render, staticRenderFns } from "./CookiesConsent.vue?vue&type=template&id=e84092b8&"
import script from "./CookiesConsent.vue?vue&type=script&lang=ts&"
export * from "./CookiesConsent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports